import { useFeatureToggle, useMediaQuery, useMantineTheme } from 'hooks'
import { Stack, Skeleton } from 'components'
import { arcHeroContentOffset } from 'components/ArcPageShell/constants'

export const GuardianDashboardSkeleton = () => {
  const theme = useMantineTheme()
  const isMobile = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`)
  const isArcEnabled = useFeatureToggle('arc-mosaico-project') as boolean

  return (
    // Arc: hero clearance compensates the reduced container top padding (AR-578)
    <Stack spacing='md' mt={isArcEnabled ? arcHeroContentOffset(isMobile ? 0 : 80, isMobile) : isMobile ? 0 : 80}>
      <Skeleton height={70} />
      <Skeleton height={106} />
      <Skeleton height={80} />
      <Skeleton height={50} />
      <Skeleton height={430} />
    </Stack>
  )
}
